import "jquery";
import "jquery.marquee";
import 'jquery-collapse/src/jquery.collapse';
import "slick-carousel";
import "waypoints/lib/jquery.waypoints";

import global from './global';
import home from './pages/home';
import collections from './pages/collections';
import product from './pages/product';
import addresses from './pages/addresses';
import login from './pages/login';

global();
home();
collections();
product();
addresses();
login();